import {
  Hero,
  Values,
  Stores,
  Divider,
  Highlights,
} from '@components';

import { NextSeo } from 'next-seo';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { stringify } from 'qs';
import { DefaultLayout } from '@layouts';
import { filter } from 'lodash';

export default function Home({ data, stores }) {
  const {
    seo,
    values,
    parallax,
    stores: storesHeader,
    hero,
    highlights,
  } = data;
  return (
    <>
      <NextSeo
        title={`Momento | ${seo?.metaTitle}`}
        description={seo?.metaDescription}
      />
      <DefaultLayout
        showBookingCta
        header={
          <Hero
            isHero
            label={hero?.label}
            title={hero?.title}
            description={hero?.description}
            hasSlider={hero?.media?.data?.length > 0}
            slides={
              hero?.media?.data?.length > 0 &&
              hero?.media?.data?.map(({ attributes }) => {
                return {
                  img: attributes,
                };
              })
            }
          />
        }
      >
        {highlights && (
          <Highlights
            header={{
              ...highlights?.header,
              cta: { ...highlights?.cta },
            }}
            slides={highlights?.banner}
          />
        )}

        <Stores {...storesHeader} list={stores} />

        <Divider {...parallax} />

        <Values list={values?.data} />
      </DefaultLayout>
    </>
  );
}

export async function getServerSideProps({ res, locale }) {
  res.setHeader(
    'Cache-Control',
    'public, s-maxage=10, stale-while-revalidate=59',
  );

  const path = process.env.NEXT_PUBLIC_STRAPI;

  const populateHome = stringify(
    {
      populate: [
        'hero.list',
        'hero.media',
        'values.list',
        'values.img',
        'values.cta',
        'parallax',
        'parallax.img',
        'parallax.cta',
        'locations',
        'stores',
        'stores.hero',
        'stores.media',
        'highlights.list',
        'highlights.img',
        'highlights.header',
        'highlights.header.cta',
        'highlights.header.cta.file',
        'highlights.banner',
        'highlights.banner.cta',
        'highlights.banner.img',
        'seo',
        'img.data',
      ],
      locale,
    },
    { encodeValuesOnly: true },
  );

  const populateStores = stringify(
    {
      populate: [
        'hero',
        'hero.media',
        'location',
        'location.data',
        'city',
        'city.data',
        'cta',
        'img',
        'category',
      ],

      sort: ['slug'],
      locale,
    },
    { encodeValuesOnly: true },
  );

  const populateLocations = stringify(
    { populate: ['stores', 'stores.data'], locale },
    { encodeValuesOnly: true },
  );

  // HomePage Data
  const getHomePage = await fetch(
    `${path}/home-page?populate=${populateHome}`,
  );
  const homePage = await getHomePage?.json();

  // Stores data
  const getStores = await fetch(`${path}/stores?${populateStores}`);
  const getStoresData = await getStores?.json();

  // Locations data
  const getLocations = await fetch(
    `${path}/locations?sort=slug&populate=${populateLocations}`,
  );
  const getLocationsData = await getLocations?.json();

  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
      data: homePage?.data?.attributes || {},
      stores: [...getStoresData?.data],
      locations: [...getLocationsData?.data],
    },
  };
}
